import {ccButtonConstants, ccButtonPropsDefaults, getValidType, getValidSize} from '../index';
import handleClick from '../../../../../utils/handleClick';
import computeClassName from '../../../../../utils/computeClassName';

const constants = Object.freeze({
  COMPONENT_NAME: 'CcButtonPrimary',
  CLASSNAME_BASE: 'appearance-none font-bold transition-cc-colors duration-100 ease-linear',
  CLASSNAME_IS_DISABLED: {
    true: 'cursor-auto bg-cc-muted text-cc-muted-contrast rounded-full',
    false: 'cursor-pointer bg-cc-accent hover:bg-cc-accent-60 focus:outline-none focus-visible:outline-none focus:shadow-pf-focus text-cc-accent-contrast rounded-full',
  },
  CLASSNAME_SIZE: Object.fromEntries(
    new Map([
      [ccButtonConstants.SIZE_SMALL, 'px-4 py-2 text-cc-body-small'],
      [ccButtonConstants.SIZE_MEDIUM, 'px-6 py-2.5 text-cc-body-medium'],
      [ccButtonConstants.SIZE_LARGE, 'px-8 py-4 text-cc-body-large']
    ])
  ),
});

export default function CCButtonPrimary(
  {
    size = ccButtonPropsDefaults.size,
    type = ccButtonPropsDefaults.type,
    title = ccButtonPropsDefaults.title,
    clickFn = ccButtonPropsDefaults.clickFn,
    clickFnArgs = ccButtonPropsDefaults.clickFnArgs,
    isDisabled = ccButtonPropsDefaults.isDisabled,
    className = '',
    children
  }
) {
  const validSize = getValidSize(size, constants.COMPONENT_NAME);
  const validType = getValidType(type, constants.COMPONENT_NAME);
  const computedClassName =
    computeClassName(
      className,
      `${constants.CLASSNAME_BASE} ${constants.CLASSNAME_IS_DISABLED[isDisabled]} ${constants.CLASSNAME_SIZE[validSize]}`);
  let dynamicProps = {};
  if (isDisabled) {
    dynamicProps['disabled'] = true;
  }
  else {
    dynamicProps['onClick'] = handleClick(clickFn, clickFnArgs);
  }

  return (
    <button type={validType}
            className={computedClassName}
            {...dynamicProps}>
      {
        !children &&
        <span className="flex flex-row items-center justify-center">{title}</span>
      }
      {
        !!children &&
        <span className="flex flex-row items-center justify-center">{children}</span>
      }
    </button>
  )
}
